// @ts-check
import { config } from './config.js';
import { restaurarEstilo } from '../state/visual-style.js';

/**
 * Arranque de la aplicación. Valida la configuración pública y aplica las
 * preferencias visuales que no dependen de la sesión.
 * @returns {Promise<void>}
 */
export async function bootstrap() {
  if (!config.apiBaseUrl) {
    throw new Error('Configuración pública incompleta: apiBaseUrl');
  }

  // Estilo visual (rediseño, Fase 2c). El PRIMER pintado ya sale con el
  // estilo correcto gracias a `public/estilo-inicial.js`, en el `<head>` de
  // cada página. Aquí, en el arranque común, se migran las preferencias de
  // antes del rediseño (una sola vez) y se reafirma el estilo, también en las
  // páginas que no montan ninguna barra.
  //
  // Las barras vuelven a llamarlo (`pages/nav-acciones.js`). Es idempotente:
  // escribir dos veces el mismo `data-estilo` no cuesta nada y hace que
  // ninguna de las dos capas dependa de la otra.
  //
  // Ya no hay tema claro/oscuro que aplicar: cada estilo decide su modo.
  restaurarEstilo();
}
